import * as React from 'react';
import '../css/progress-bar.sass';

export interface ProgressBarProps {
    value: number;
    maxProgress?: number;
}

export default function ProgressBar(props:ProgressBarProps){
    const {maxProgress=100} = props;
    return <div>{(props.value < maxProgress)&&<progress value={props.value} max={maxProgress}/>}</div>;

}